/**
 *
 * PasswordRequirementsModal
 *
 */

import React from 'react';
import {
  Wrapper,
  Text,
} from './styledComponents'
import { Link } from 'react-router-dom';

import Modal from 'components/Modal';
import H1 from 'components/H1';

const HasAlreadySignedUpModal = ({ close }) => (
  <Modal close={close} title='Already a user'>
    <Wrapper>
      <Text>
        It looks like the email address you used to sign up is already associated with a user account. Please <Link to='/sign-in' onClick={ () => this.close() }>sign in </Link> to that account or choose a different email address.
      </Text>
    </Wrapper>
  </Modal>
);

export default HasAlreadySignedUpModal;



// WEBPACK FOOTER //
// ./src/components/HasAlreadySignedUpModal/index.js